export default function(label: string, truncate: boolean = false): string {
    const formattedLabel = label.substring(0, 1) + label.substring(1, label.length).toLocaleLowerCase();
    
    if (formattedLabel.length < 10 || !truncate) {
        return formattedLabel;
    }

    return formattedLabel.substring(0, 10) + "...";
}